module.exports = __webpack_public_path__ + "img/japan-ovarian-cancer-female.15752d83.png";